import { alpha, Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .ISIncludedItemsGrid': {
    alignItems: 'stretch',
    '&:nth-child(odd)': {
      backgroundColor: alpha(theme.palette.common.white, 0.05),
    },
    '&:last-child': {
      '& .ISIncludedLeftGrid': {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(0, 0, 0.5, 0.5),
      },
    },
  },
  '& .ISIncludedGrid': {
    padding: theme.spacing(2, 3),
    '&.ISIncludedLeftGrid': {
      borderLeft: `1px solid ${theme.palette.primary.main}`,
      borderRight: `1px solid ${theme.palette.primary.main}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&.ISIncludedCell': {
        padding: theme.spacing(3),
        borderTop: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(0.5, 0.5, 0, 0),
      },
    },
  },
  '& .ISIncludedIcon': {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(3),
  },
  '& .ISInfoIcon': {
    fontSize: theme.spacing(2.5),
    position: 'relative',
    top: theme.spacing(0.75),
    paddingLeft: theme.spacing(0.5),
  },
}));
export default StyledBox;
